import { useState } from 'react';
import { fetchMetaCreativeDraft } from '../../services/meta-api.js';
import { WorkbenchHead } from './MetaWorkbenchUi.jsx';

export default function MetaCreativeStudio() {
  const [fields, setFields] = useState({
    project: '', verifiedFacts: '', audience: 'Personas interesadas en evaluar inversión inmobiliaria en Chile',
    objective: 'meeting', format: 'reel', tone: 'profesional'
  });
  const [draft, setDraft] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const update = (key) => (e) => setFields((f) => ({ ...f, [key]: e.target.value }));
  async function generate(event) {
    event.preventDefault();
    setLoading(true); setError(''); setDraft(null);
    try {
      const result = await fetchMetaCreativeDraft(fields);
      setDraft(result);
    } catch (e) {
      setError(e.message || 'No fue posible generar borradores.');
    } finally {
      setLoading(false);
    }
  }
  function copyVariant(item) {
    const plain = [item.hook, item.primaryText, item.headline, 'CTA: ' + item.callToAction,
      'Idea visual: ' + item.visualIdea].join('\n\n');
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(plain).catch(() => setError('No se pudo copiar el borrador.'));
    } else setError('El navegador no permite copiar automáticamente.');
  }
  return <section className="mgw-panel">
    <WorkbenchHead number="09" title="Estudio creativo" description="Borradores con IA · revisión humana obligatoria" />
    <p className="mgw-muted">Prepara mensajes, anuncios y guiones para pruebas. No se envían publicaciones a Meta ni se modifica el presupuesto.</p>
    <form className="mgw-creative-form" onSubmit={generate}>
      <label>Proyecto o servicio<input required minLength={3} maxLength={180} value={fields.project} onChange={update('project')} placeholder="Ej.: diagnóstico patrimonial GI Capital" /></label>
      <label>Hechos comerciales a utilizar<textarea required minLength={15} maxLength={3000} rows={3} value={fields.verifiedFacts} onChange={update('verifiedFacts')} placeholder="Escribí datos respaldados por la ficha comercial, sin promesas no verificadas." /></label>
      <label>Público objetivo (sin datos sensibles)<textarea required minLength={5} maxLength={600} rows={2} value={fields.audience} onChange={update('audience')} /></label>
      <div className="mgw-creative-choices">
        <label>Objetivo<select value={fields.objective} onChange={update('objective')}><option value="meeting">Reuniones</option><option value="leads">Leads</option><option value="whatsapp">WhatsApp</option></select></label>
        <label>Formato<select value={fields.format} onChange={update('format')}><option value="reel">Reel</option><option value="story">Historia</option><option value="feed">Feed</option></select></label>
        <label>Tono<select value={fields.tone} onChange={update('tone')}><option value="profesional">Profesional</option><option value="cercano">Cercano</option><option value="educativo">Educativo</option></select></label>
      </div>
      <button className="mgw-btn" type="submit" disabled={loading}>{loading ? 'Generando propuestas…' : 'Crear 3 propuestas para revisar'}</button>
    </form>
    {error ? <p role="alert" className="mgw-alert">{error}</p> : null}
    {draft ? <>
      <div className="mgw-notice">{draft.notice}</div>
      <div className="mgw-draft-grid">{(draft.variants || []).map((item, i) =>
        <article className="mgw-draft" key={i}>
          <span className="mgw-eyebrow">Enfoque {i + 1}: {item.angle}</span>
          <h3>{item.hook}</h3>
          <p>{item.primaryText}</p>
          <p><strong>Titular:</strong> {item.headline}</p>
          <p><strong>CTA:</strong> {item.callToAction}</p>
          <p><strong>Visual sugerido:</strong> {item.visualIdea}</p>
          <p><strong>Hipótesis:</strong> {item.testHypothesis}</p>
          <button className="mgw-btn is-secondary" type="button" onClick={() => copyVariant(item)}>Copiar borrador</button>
        </article>)}</div>
      <details className="mgw-method"><summary>Controles antes de publicar</summary>
        <ul>{(draft.complianceChecklist || []).map((item, i) => <li key={i}>{item}</li>)}</ul>
      </details>
    </> : null}
  </section>;
}

